<app-add-empresa
  (mostrarBotones)="ocultarBotones($event)"
  [empresas]="empresas"></app-add-empresa>
<mat-card-content class="catalog-list" *ngFor="let empresa of empresas">
  <div *ngIf="admonCatEmpresaStatus$ | async as empresaStatus">
    <mat-card
      class="catalog-card"
      *ngIf="
        !empresaStatus.mostrarEditar ||
        (empresaStatus.mostrarEditar && registroSeleccionado !== empresa)
      ">
      <div class="catalog-card-view">
        <p class="catalog-title" style="padding: 1rem">
          {{ empresa?.descripcion }}
        </p>

        <mat-card-actions
          align="end"
          class="nuevo-catalogo-actions"
          *ngIf="!empresaStatus.mostrarEditar && !empresaStatus.mostrarNuevo">
          <button
            class="uppercase-button"
            mat-button
            (click)="editarRegistro(empresa)">
            Editar
          </button>
          <button
            class="uppercase-button"
            mat-button
            (click)="eliminarEmpresa(empresa)">
            Borrar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
    <mat-card
      class="catalog-card"
      *ngIf="empresaStatus.mostrarEditar && registroSeleccionado === empresa">
      <div class="catalog-card-header">
        <p class="catalog-title">
          {{ empresa?.descripcion }}
        </p>
      </div>
      <div class="flex pl-4 pr-4 pt-2 pb-2">
        <form [formGroup]="editarForm" class="w-1/2">
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Descripción</mat-label>
            <input
              required
              formControlName="descripcion"
              name="descripcion"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              (input)="
                existeRegistro(
                  editarForm.get('descripcion'),
                  empresa?.descripcion
                )
              "
              placeholder="" />
            <mat-hint align="end"
              >{{ editarForm.get("descripcion")?.value.length }} / 50</mat-hint
            >

            @if ( editarForm.get('descripcion')?.touched && editarForm
            .get('descripcion')?.hasError('campoRequerido')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if ( editarForm.get('descripcion')?.touched &&
            editarForm.get('descripcion')?.hasError('descripcionCatalogo')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            } @if ( editarForm.get('descripcion')?.touched &&
            editarForm.get('descripcion')?.hasError('descripcionDuplicad@')) {
            <mat-error> La descripción ya se encuentra registrada. </mat-error>
            }
          </mat-form-field>
        </form>
        <mat-card-actions
          align="end"
          class="nuevo-catalogo-actions"
          class="w-1/2">
          <button
            class="uppercase-button"
            mat-button
            (click)="cancelarEdicion()">
            Cancelar
          </button>
          <button
            class="uppercase-button"
            mat-button
            [disabled]="editarForm.invalid"
            (click)="guardarCambios(empresa)">
            Guardar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
</mat-card-content>
<br />
